import classNames from 'classnames';
import React, {ReactElement} from 'react';

import {formatNumber} from '../../decision/util';

type Props = {
  savings?: number;
};

const EmissionsSavingBox = ({savings}: Props): ReactElement => {
  return (
    <div
      className={classNames(
        'border-thin border-primary-300 rounded-[20px] px-lg py-xs text-center',
        savings === undefined && 'invisible'
      )}
    >
      <p className={'text-sm font-bold'}>Potential saving of</p>
      <p className={'text-xl font-bold'}>{formatNumber(savings)} tCO²e</p>
      <p className={'text-sm text-gray-200'}>(Carbon Dioxide Equivalent)</p>
      <p className={'text-sm font-bold'}>per hectare over the next 20 years</p>
    </div>
  );
};

export default EmissionsSavingBox;
